import { t } from "@lingui/macro";
import * as React from "react";
import { Path } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const MergeIcon = (props: IconProps) => {
  return (
    <Icon viewBox="0 0 16 16" fill="none" title={t`Merge`} {...props}>
      <Path
        d="M5 14l3-3-3-3M11 2L8 5l3 3M1 11h7M8 5h7"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  );
};
